var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.getters.getDashboardV2)?_c('div',{class:{
      'in-embed': _vm.isEmbed,
      'hide-logo': _vm.hideLogo,
      'login-page':
        _vm.$router.history.current.path &&
        _vm.$router.history.current.path.indexOf('/login/') === 0,
      'is-agent': _vm.isAgent,
    },attrs:{"id":"app"},on:{"click":function($event){return _vm.handleClickApp($event)}}},[_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),(!_vm.isEmbed)?_c('app-footer',{staticClass:"footer-panel"}):_vm._e(),_vm._v(" "),_c('ErrorDialog'),_vm._v(" "),_c('ResultDialog'),_vm._v(" "),_c('ConfirmDialog'),_vm._v(" "),_c('InfoDialog'),_vm._v(" "),_c('InputDialog'),_vm._v(" "),_c('FilePreviewDialog'),_vm._v(" "),(_vm.isLoading)?_c('SpinnerLoading'):_vm._e(),_vm._v(" "),_c('vue-simple-context-menu',{ref:"contextMenu",attrs:{"elementId":"context-menu","options":_vm.$store.getters.contextMenu.options},on:{"option-clicked":_vm.contextMenuOptionClicked}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8167f170","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 650
// module chunks = 38